import React from 'react'
import { connect } from 'react-redux'
import { useIntl } from 'react-intl'
import { Dialog } from 'primereact/dialog'
import { LuxButton, LuxRichInputText } from '@lux/wardrobe-lib'
import './DialogOnlyText.scss'

const DialogOnlyText = (props: {
    dialogVisible: boolean
    dialogTitle: string
    dialogDescription: string
    onSave: () => void
    onHide: () => void
}) => {
    const { dialogVisible, dialogTitle, dialogDescription, onSave, onHide } = props

    const componentClass = 'smart-modals-dialog-onlyText'

    const intl = useIntl()

    const renderFooter = () => {
        return (
            <div className={`${componentClass}__buttons`}>
                <LuxButton
                    variant={'outlined'}
                    onClick={() => onHide()}
                    text={intl.formatMessage({
                        id: 'modals.dialog.delegation_dialog.button.cancel',
                        defaultMessage: 'Cancel',
                    })}
                />
                <LuxButton
                    onClick={() => onSave()}
                    text={intl.formatMessage({
                        id: 'modals.dialog.redo_dialog.button.confirm',
                        defaultMessage: 'Confirm',
                    })}
                />
            </div>
        )
    }

    return (
        <Dialog
            draggable={false}
            header={dialogTitle}
            visible={dialogVisible}
            onHide={() => onHide()}
            footer={renderFooter()}
            style={{ width: '25vw' }}
            maskClassName={componentClass}
            breakpoints={{ '960px': '85vw' }}>
            <div className={`${componentClass}__description`}>{dialogDescription}</div>
        </Dialog>
    )
}

const mapStateToProps = (state: any) => ({})

const mapDispatchToProps = (dispatch: any) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(DialogOnlyText)
